<template>
    <div id="page" class="container-fluid">
        <div class="row header mx-4 mt-3">
            <div class="col header-row">
                <h1>Insurance Verification</h1>
            </div>
            <div class="row filter-row mb-1">
                  <div class="patient-search-section mr-2">
                    <b-input-group class="patient-search-border text-right">
                        <b-form-input ref="searchInput"
                                      placeholder="Filter (Patient Name or ID)"
                                      class="patient-search" v-model="searchTerm">
                        </b-form-input>
                        <b-input-group-append>
                            <button class="btn btn-default patient-search-submit" type="button">
                                <font-awesome-icon icon="search"/>
                            </button>
                        </b-input-group-append>
                    </b-input-group>
                  </div>
                  <b-form-group class="mr-2" label-class="ml-2" label="Start Date">
                    <b-form-datepicker class="orange-border form-control datepicker" :hide-header="true" :value-as-date="true" v-model="fromDate" :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"/>
                  </b-form-group>
                  <b-form-group class="mr-2" label-class="ml-2" label="Start Time">
                    <b-form-timepicker class="orange-border form-control" :hide-header="true" v-model="fromTime"/>
                  </b-form-group>

                  <b-form-group class="mr-2" label-class="ml-2" label="End Date">
                    <b-form-datepicker class="orange-border form-control datepicker" :hide-header="true" :value-as-date="true" v-model="toDate" :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"/>
                  </b-form-group>
                  <b-form-group class="mr-2" label-class="ml-2" label="End Time">
                    <b-form-timepicker class="orange-border form-control" offset="-100" :hide-header="true" v-model="toTime"/>
                  </b-form-group>
            </div>
        </div>
          <div class="row header">
            <div class="col ml-4">
            </div>
              <div class="row text-right mx-4 pb-4">
                <b-form-checkbox class="mr-2 mt-2" v-model="includeMismatches">
                  <span style="vertical-align:middle"> Only Show Policy Mismatches</span>
                </b-form-checkbox>
                <b-btn @click.stop="statusPopoverShowing = !statusPopoverShowing" id="verificationStatuses" variant="outline-orange"><font-awesome-icon class="orange mr-2" :icon="[ 'far', 'bars-progress' ]"/>Statuses<b-badge v-show="selectedVerificationStatuses.length > 0" variant="orange" class="ml-2">{{ selectedVerificationStatuses.length }}</b-badge></b-btn>
                <b-popover :show.sync="statusPopoverShowing"
                           target="verificationStatuses" placement="bottomleft" triggers="">
                    <b-form-group v-click-outside="hideStatusPopover" class="status-popover" label="Verification Status">
                        <b-form-checkbox-group stacked v-model="selectedVerificationStatuses" name="verificationStatuses" :options="verificationStatuses">
                        </b-form-checkbox-group>
                    </b-form-group>
                </b-popover>
                <button name="locations" class="btn btn-outline-orange providers-filter" @click.prevent="showingLocationList = !showingLocationList">
                  <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'location-dot' ]"/>Locations <b-badge v-show="selectedLocationIds.length > 0" variant="orange" class="ml-1">{{ selectedLocationIds.length }}</b-badge>
                </button>

                <button name="providers" class="btn btn-outline-orange providers-filter" @click.prevent="showingProviderList = !showingProviderList">
                  <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'user-doctor' ]"/>Providers <b-badge v-show="selectedProviderIds.length > 0" variant="orange" class="ml-1">{{ selectedProviderIds.length }}</b-badge>
                </button>

                <button name="insurances" class="btn btn-outline-orange providers-filter" @click.prevent="showingInsuranceList = !showingInsuranceList">
                  <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'hospital-user' ]"/>Insurances <b-badge v-show="selectedInsuranceIds.length > 0" variant="orange" class="ml-1">{{ selectedInsuranceIds.length }}</b-badge>
                </button>
              <button name="refresh" class="btn btn-outline-orange providers-filter mr-2" @click.prevent="loadVisits()">
                <font-awesome-icon :icon="['fas', 'redo']"/>
              </button>
              </div>
            </div>
        <div class="container-fluid">
            <div class="row visits-header">
                <div class="col-3"><img style="width:20px;" src="../assets/q-logo.svg"> &nbsp;
                    Patient
                </div>
                <div class="col-3">Appointment</div>
                <div class="col-3">Primary Insurance</div>
                <div class="col-3">Secondary Insurance</div>
            </div>
            <div v-for="visit in visits" class="row visit-row" :key="visit.visitId">
                <div class="col-12">
                    <div class="row">
                        <div class="col-3 column align-middle">
                            <h5 class="mb-2"><a @click.prevent="editPatient(visit.organizationPatientId)" href="#">{{ visit.firstName + ' ' + visit.lastName }}&nbsp;&nbsp;<font-awesome-icon size="sm" :icon="['far', 'edit']"/></a></h5>
                          <div class="dob-wrapper"><span class="field-label mr-1">Birth Date: </span>{{ formatBirthDate(visit.dob) }}
                          <div v-if="isOver65(visit.dob)"><font-awesome-icon class="orange ml-1" :icon="['far', 'calendar-circle-user']" /></div></div>
                          <span class="field-label">MRN: </span>{{ visit.mrn }}<br>
                            <span class="field-label">Patient ID: </span>{{ visit.patientIdFromOrg }}<br>
                            <span class="field-label">Mobile Phone: </span>{{ visit.mobilePhone }}<br>
                            <span class="field-label">E-Mail: </span>{{ visit.email }}<br>
                        </div>
                        <div class="col-3 column">
                            <h5 class="mb-2">{{ formatAppointmentDate(visit.appointmentStartDate) }}</h5>
                            <span class="field-label">Location: </span>{{ visit.location.name }}<br>
                            <span class="field-label">Provider: </span>{{ visit.provider ? visit.provider.displayName : 'No Provider Specified'}}<br>
                            <span class="field-label">Service Type: </span>{{ visit.appointmentTypeText }}<br>
                        </div>
                        <div class="col-3 column">
                            <template v-if="visit.primaryInsurance">
                            <h5 class="mb-2"><a @click.prevent="showInsuranceDetails(visit, 'primary')" href="#">{{ visit.primaryInsurance.insuranceCompany }}&nbsp;<font-awesome-icon size="sm" :icon="['far', 'edit']"/></a></h5>
                            <span class="field-label">Plan: </span>{{ visit.primaryInsurance.insurancePlan }}<br>
                              <div v-if="visit.primaryInsurance && visit.primaryInsurance.referralRequired === true">
                                <u>Referral Required</u>
                              </div>
                              <template v-if="visit.primaryInsurance.verification">
                                <div v-if="visit.primaryInsurance.verification.hasMetIndividualMaxOop === true">
                                  <u>Individual Max Oop Met</u>
                                </div>
                                <div v-if="visit.primaryInsurance.verification.hasMetFamilyMaxOop === true && visit.primaryInsurance.verification.hasMetIndividualMaxOop === false">
                                  <u>Family Max Oop Met</u>
                                </div>
                            <div class="verification-status-container">
                                <span class="field-label">Status: </span>
                                <b-badge v-show="visit.primaryInsurance.verification.insuranceEligibilityStatus == 'Verified'" class="thin" pill variant="success">Verified</b-badge>
                                <b-badge v-show="visit.primaryInsurance.verification.insuranceEligibilityStatus == 'InsuranceError' || visit.primaryInsurance.verification.insuranceEligibilityStatus == 'SystemError'" class="thin" pill variant="danger">Error</b-badge>
                                <b-badge v-show="visit.primaryInsurance.verification.insuranceEligibilityStatus == 'Pending' || visit.primaryInsurance.verification.insuranceEligibilityStatus == 'NotVerified'" class="thin" pill variant="secondary">Pending</b-badge>
                                <b-badge v-show="visit.primaryInsurance.verification.insuranceEligibilityStatus == 'NotMapped'" class="thin" pill variant="secondary">UnMapped</b-badge>
                            </div>
                                <div v-if="visit.primaryInsurance.verification.insuranceEligibilityStatus == 'Verified'">
                                <span class="field-label">Verification: </span><a @click.prevent="showInsuranceVerificationDetails(visit.primaryInsurance.verification)" href="#">View Verification Details</a><br>
                                </div>
                                <div v-if="visit.primaryInsurance.benefitInformationPresent === true">
                                  <span class="field-label">Eligibility: </span><a @click.prevent="viewBenefits(visit.primaryInsurance.verification.visitInsuranceEligibilityId)" href="#">View Eligibility Details</a><br>
                                </div>
                            <div v-if="visit.primaryInsurance.verification" class="mt-2" v-show="visit.primaryInsurance.verification.insuranceEligibilityStatus == 'InsuranceError' || visit.primaryInsurance.verification.insuranceEligibilityStatus == 'SystemError' || visit.primaryInsurance.verification.insuranceEligibilityStatus == 'NotMapped'">
                                <b><font-awesome-icon size="sm" class="danger" icon="exclamation-triangle"/> {{ visit.primaryInsurance.verification.verificationError}}</b>
                            </div>
                              <div v-if="visit.primaryInsurance.policyNumberFromVerification != null" class="mt-2">
                                <b><font-awesome-icon size="sm" class="danger" icon="exclamation-triangle"/> Policy Number Mismatch</b>
                              </div>
                            </template>
                            </template>
                          </div>
                        <div class="col-3 column">
                            <template v-if="visit.secondaryInsurance">
                            <h5 class="mb-2"><a @click.prevent="showInsuranceDetails(visit, 'secondary')" href="#">{{ visit.secondaryInsurance.insuranceCompany }}&nbsp;<font-awesome-icon size="sm" :icon="['far', 'edit']"/></a></h5>
                            <span class="field-label">Plan: </span>{{ visit.secondaryInsurance.insurancePlan }}<br>
                              <div v-if="visit.secondaryInsurance && visit.secondaryInsurance.referralRequired === true">
                                <u>Referral Required</u>
                              </div>
                            <template v-if="visit.secondaryInsurance.verification">
                              <div v-if="visit.secondaryInsurance.verification.hasMetIndividualMaxOop === true">
                                <u>Individual Max Oop Met</u>
                              </div>
                              <div v-if="visit.secondaryInsurance.verification.hasMetFamilyMaxOop === true && visit.secondaryInsurance.verification.hasMetIndividualMaxOop === false">
                                <u>Family Max Oop Met</u>
                              </div>
                            <span class="field-label">Status: </span>{{ visit.secondaryInsurance.verification.insuranceEligibilityStatus }}<br>
                            </template>
                            <template v-if="visit.secondaryInsurance.verification">
                            <div class="verification-status-container">
                                <span class="field-label">Status: </span>
                                <b-badge v-show="visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'Verified'" class="thin" pill variant="success">Verified</b-badge>
                                <b-badge v-show="visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'InsuranceError' || visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'SystemError'" class="thin" pill variant="danger">Error</b-badge>
                                <b-badge v-show="visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'Pending' || visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'NotVerified'" class="thin" pill variant="secondary">Pending</b-badge>
                                <b-badge v-show="visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'NotMapped'" class="thin" pill variant="secondary">UnMapped</b-badge>
                            </div>
                            <div class="mt-2" v-show="visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'InsuranceError' || visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'SystemError' || visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'NotMapped'">
                                <b><font-awesome-icon size="sm" class="danger" icon="exclamation-triangle"/> {{ visit.secondaryInsurance.verification.verificationError}}</b>
                            </div>
                              <div v-if="visit.secondaryInsurance.verification.insuranceEligibilityStatus === 'Verified'">
                                <span class="field-label">Verification: </span><a @click.prevent="showInsuranceVerificationDetails(visit.secondaryInsurance.verification)" href="#">View Verification Details</a><br>
                              </div>
                              <div v-if="visit.secondaryInsurance.benefitInformationPresent === true">
                                <span class="field-label">Eligibility: </span><a @click.prevent="viewBenefits(visit.secondaryInsurance.verification.visitInsuranceEligibilityId)" href="#">View Eligibility Details</a><br>
                              </div>
                            </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="alert alert-secondary" role="alert" v-show="!visits.length && !errors.length">
            &nbsp;&nbsp;No visits were found for the specified criteria
        </div>

        <div class="row justify-content-center m-2">
            <div class="alert alert-danger col-6" role="alert" v-show="errors.length > 0">
                <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
            </div>
        </div>

      <location-select @saveLocationIds="locationSelectionChanged"
                       :selected-location-ids="selectedLocationIds" :visible="showingLocationList"
                       @update:visible="visible => showingLocationList = visible"></location-select>

      <provider-select @saveProviderIds="providerSelectionChanged"
                       :selected-provider-ids="selectedProviderIds" :visible="showingProviderList"
                       @update:visible="visible => showingProviderList = visible"></provider-select>

      <insurance-select @saveInsuranceIds="insuranceSelectionChanged"
                        :selected-insurance-ids="selectedInsuranceIds" :org-insurance-companies="orgInsuranceCompanies" :visible="showingInsuranceList"
                        @update:visible="visible => showingInsuranceList = visible"></insurance-select>

      <edit-insurance-modal :visit-id="editingInsuranceVisitId" :insurance-details="editingInsurance" @insuranceUpdated="insuranceUpdated" :title="insuranceDetailsTitle" :visible="showingInsuranceDetails" @update:visible="visible => showingInsuranceDetails = visible"></edit-insurance-modal>
      <edit-patient-modal :id="editingPatientId" @patientUpdated="patientUpdated" :visible="showingPatientDetails" @update:visible="visible => showingPatientDetails = visible"></edit-patient-modal>

      <loading-modal :visible="showingLoadingModal" @update:visible="visible => showingLoadingModal = visible"></loading-modal>

      <paginator :totalPages="totalPages" :currentPage="currentPage" @update:currentPage="newPage => currentPage = newPage"></paginator>
      <insurance-verification-modal :visible="showingInsuranceVerificationDetails" @update:visible="visible => showingInsuranceVerificationDetails = visible" :verificationDetails="visitInsuranceVerificationDetails" :title="insuranceVerificationModalTitle"></insurance-verification-modal>
    </div>
</template>

<script>
  import store from '../services/store'
  import api from '../services/api'
  import moment from 'moment'
  import LoadingModal from '../components/LoadingModal'
  import Paginator from '../components/Paginator'
  import EditInsuranceModal from '../components/EditInsuranceModal'
  import _ from 'lodash'
  import EditPatientModal from '../components/EditPatientModal'
  import ProviderSelect from '../components/ProviderSelect'
  import LocationSelect from '../components/LocationSelect'
  import InsuranceSelect from '../components/InsuranceSelect'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'
  import InsuranceVerificationModal from '@/components/InsuranceVerificationModal.vue'

  export default {
    name: 'insurance-verification',

    components: {
      InsuranceVerificationModal,
      LoadingModal,
      Paginator,
      EditInsuranceModal,
      EditPatientModal,
      ProviderSelect,
      LocationSelect,
      InsuranceSelect
    },

    mixins: [AnalyticsMixin],

    data () {
      return {
        showingProviderList: false,
        showingLocationList: false,
        showingInsuranceList: false,
        visits: [],
        searchTerm: '',
        fromDate: moment().startOf('day').utc().toJSON(),
        fromTime: '00:00',
        toDate: moment().startOf('day').add(1, 'day').utc().toJSON(),
        toTime: '23:59',
        selectedProviderIds: [],
        selectedLocationIds: [],
        selectedInsuranceIds: [],
        day: moment().startOf('day').utc().toJSON(),
        showingLoadingModal: false,
        showAutoVerified: true,
        showManualVerified: true,
        showRefundConfirmation: false,
        totalPages: 0,
        currentPage: 1,
        errors: [],
        pageSize: 20,
        editingInsurance: {
          verification: {
            insuranceEligibilityStatus: ''
          }
        },
        editingInsuranceVisitId: 0,
        statusPopoverShowing: false,
        showingInsuranceDetails: false,
        insuranceDetailsTitle: '',
        verificationStatuses: [
          { text: 'Pending', value: 1 },
          { text: 'Verified', value: 2 },
          { text: 'System Error', value: 3 },
          { text: 'Insurance Error', value: 4 },
          { text: 'Not Verified', value: 5 }
        ],
        selectedVerificationStatuses: [2, 3, 4, 5],
        editingPatientId: 0,
        showingPatientDetails: false,
        orgInsuranceCompanies: [],
        restoringSettings: false,
        searchDebounceFn: null,
        includeMismatches: false,
        showingInsuranceVerificationDetails: false,
        visitInsuranceVerificationDetails: {},
        insuranceVerificationModalTitle: 'Insurance Verification Details'
      }
    },

    computed: {
      providers () {
        return store.providers
      },

      organization () {
        return store.organization
      },

      user () {
        return store.user
      },

      fromDateTime () {
        if (this.fromTime) {
          return moment(moment(this.fromDate).format('YYYY/MM/DD') + ' ' + this.fromTime, 'YYYY/MM/DD HH:mm').toDate()
        } else {
          return moment(this.fromDate).toDate()
        }
      },

      toDateTime () {
        if (this.toTime) {
          return moment(moment(this.toDate).format('YYYY/MM/DD') + ' ' + this.toTime, 'YYYY/MM/DD HH:mm').toDate()
        } else {
          return moment(this.toDate).toDate()
        }
      }
    },

    watch: {
      fromDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },

      toDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      fromTime (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      toTime (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      includeMismatches (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },

      selectedVerificationStatuses (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          if (newValue.length === 0) {
            this.selectedVerificationStatuses = [2, 3, 4, 5]
          }
          this.searchDebounceFn()
        }
      },
      day (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      searchTerm (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadVisits()
        }
      }
    },

    methods: {
      locationSelectionChanged (selectedIds) {
        this.selectedLocationIds = selectedIds
        this.showingLocationList = false
        this.loadVisits()
      },

      providerSelectionChanged (selectedIds) {
        this.selectedProviderIds = selectedIds
        this.showingProviderList = false
        this.loadVisits()
      },

      insuranceSelectionChanged (selectedIds) {
        this.selectedInsuranceIds = selectedIds
        this.showingInsuranceList = false
        this.loadVisits()
      },

      loadVisits (silent = false) {
        if (!silent) {
          this.showingLoadingModal = true
        }

        this.errors = []
        const parameters = {
          fromDate: this.fromDateTime,
          toDate: this.toDateTime,
          verificationStatuses: this.selectedVerificationStatuses,
          providerIds: this.selectedProviderIds,
          locationIds: this.selectedLocationIds,
          insuranceIds: this.selectedInsuranceIds,
          pageSize: this.pageSize,
          page: this.currentPage,
          searchTerm: this.searchTerm,
          includeMismatches: false
        }

        if (this.includeMismatches) {
          parameters.includeMismatches = true
        }

        api.post('/Dashboard/InsuranceVerification', parameters).then(response => {
          this.persistSettings()
          this.visits = response.data.visits
          this.currentPage = response.data.page
          this.totalPages = Math.ceil(response.data.totalVisits / this.pageSize)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load appointments: ' + error.message, error)
            this.errors = ['Error loading appointments: ' + error.message]
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      loadOrgInsurances () {
        api.get('/Dashboard/Organization/Insurances').then(response => {
          this.orgInsuranceCompanies = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Insurance', 'EditModalLoadOrgInsError', error.message)
            this.$log.error('Error attempting to load insurance companies: ' + error.message, error)
          }
        })
      },

      editPatient (patientId) {
        this.editingPatientId = patientId
        this.showingPatientDetails = true
      },

      patientUpdated (updatedPatient) {
        // TODO: We should update the structure of the visits list to be able to support updating the patient details directly
        this.showingPatientDetails = false
        this.loadVisits()
      },

      formatBirthDate (dob) {
        return moment(dob).utc().format('MM/DD/YYYY')
      },

      isOver65 (dob) {
        const today = new Date()
        const birthDate = new Date(dob)
        let currentAge = today.getFullYear() - birthDate.getFullYear()
        const m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          currentAge--
        }
        return currentAge >= 65
      },

      formatAppointmentDate (date) {
        return moment(date).format('MMM Do h:mm a')
      },

      hideStatusPopover () {
        if (this.statusPopoverShowing) {
          this.$root.$emit('bv::hide::popover')
        }
      },

      viewBenefits (visitInsuranceEligibilityId) {
        this.$router.push({ name: 'visit-insurance-benefits', params: { id: visitInsuranceEligibilityId, mode: 'visit' } })
      },

      showInsuranceVerificationDetails (verificationDetails) {
        this.insuranceVerificationModalTitle = verificationDetails.insurancePriority + ' Insurance Verification Details'
        this.visitInsuranceVerificationDetails = verificationDetails
        this.showingInsuranceVerificationDetails = true
      },

      showInsuranceDetails (visit, priority) {
        if (priority === 'primary') {
          this.insuranceDetailsTitle = visit.firstName + ' ' + visit.lastName + ' - Primary Insurance'
          this.editingInsurance = visit.primaryInsurance
          this.editingInsuranceVisitId = visit.visitId
        } else {
          this.insuranceDetailsTitle = visit.firstName + ' ' + visit.lastName + ' - Secondary Insurance'
          this.editingInsurance = visit.secondaryInsurance
          this.editingInsuranceVisitId = visit.visitId
        }
        this.showingInsuranceDetails = true
      },

      insuranceUpdated () {
        this.showingInsuranceDetails = false
        this.loadVisits()
      },

      handleOrgChange (newOrg, event) {
        this.loadVisits()
      },

      persistSettings () {
        const insuranceVerificationFilters = {
          fromTime: this.fromTime,
          toTime: this.toTime,
          fromDate: moment(this.fromDate).toISOString(),
          toDate: moment(this.toDate).toISOString(),
          verificationStatuses: this.selectedVerificationStatuses,
          providerIds: this.selectedProviderIds,
          locationIds: this.selectedLocationIds,
          insuranceIds: this.selectedInsuranceIds,
          includeMismatches: this.includeMismatches,
          searchTerm: this.searchTerm
        }
        localStorage.setItem('selectedInsuranceVerificationFilters', JSON.stringify(insuranceVerificationFilters))
      },

      restoreSettings () {
        this.restoringSettings = true
        const settingInsuranceVerificationFilters = localStorage.getItem('selectedInsuranceVerificationFilters')
        if (settingInsuranceVerificationFilters) {
          const insuranceVerificationFilters = JSON.parse(settingInsuranceVerificationFilters)
          if (insuranceVerificationFilters.fromDate && insuranceVerificationFilters.fromDate !== 'null') {
            this.fromDate = insuranceVerificationFilters.fromDate
          }
          if (insuranceVerificationFilters.fromTime && insuranceVerificationFilters.fromTime !== 'null') {
            this.fromTime = insuranceVerificationFilters.fromTime
          }
          if (insuranceVerificationFilters.toDate && insuranceVerificationFilters.toDate !== 'null') {
            this.toDate = insuranceVerificationFilters.toDate
          }
          if (insuranceVerificationFilters.toTime && insuranceVerificationFilters.toTime !== 'null') {
            this.toTime = insuranceVerificationFilters.toTime
          }
          if (insuranceVerificationFilters.locationIds) {
            this.selectedLocationIds = insuranceVerificationFilters.locationIds
          }
          if (insuranceVerificationFilters.providerIds) {
            this.selectedProviderIds = insuranceVerificationFilters.providerIds
          }
          if (insuranceVerificationFilters.insuranceIds) {
            this.selectedInsuranceIds = insuranceVerificationFilters.insuranceIds
          }
          if (insuranceVerificationFilters.verificationStatuses) {
            this.selectedVerificationStatuses = insuranceVerificationFilters.verificationStatuses
          }
          if (insuranceVerificationFilters.includeMismatches) {
            this.includeMismatches = insuranceVerificationFilters.includeMismatches
          }
          if (insuranceVerificationFilters.searchTerm) {
            this.searchTerm = insuranceVerificationFilters.searchTerm
          }
        }
        this.$nextTick(() => {
          this.restoringSettings = false
        })
      }
    },

    created () {
      store.$on('organization:changed', this.handleOrgChange)
      this.searchDebounceFn = _.debounce(() => {
        if (this.searchTerm === '') {
          this.totalPages = Math.ceil(this.visits.totalVisits / this.pageSize)
          this.currentPage = 1
        } else {
          this.currentPage = 1
          this.totalPages = 0
        }
        this.loadVisits()
      }, 500)
      this.restoreSettings()
      this.loadVisits()
      this.loadOrgInsurances()
    }
  }
</script>

<style scoped>
    .providers-filter {
        margin-left: 8px;
    }

    button.close {
        margin: 0px 0px 10px;
    }

    .visits-header div {
        padding: 0.75rem;
        vertical-align: bottom;
        border-top: 1px solid #dee2e6;
        border-bottom: 2px solid #dee2e6;
        font-weight: bold;
        border-collapse: collapse;
    }

    .visit-row .column {
        padding: 0.75rem;
        vertical-align: bottom;
        border-collapse: collapse;
    }

    .visit-row {
        border-bottom: 1px solid #dee2e6;
        background-color: #f9f9f9;
        /*cursor: pointer;*/
    }

    .verification-status-container span.badge {
        font-size: .95rem;
    }

    svg.danger {
        color: #dc3545;
    }

    .orange-border {
        border: 1px solid rgb(255, 70, 0);
        border-radius: 5px;
    }

    .status-popover {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
    }

    .patient-search-border {
        border: 1px solid rgb(255, 70, 0);
        border-radius: 5px;
    }

    .patient-search {
        border: none;
        border-radius: 4px 0 0 4px;
        box-shadow: none;
        padding-right: 0px;
        min-width: 230px;
        height: 36px;
    }

    .patient-search:focus {
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075),
        inset 0 0 1px rgba(255, 70, 0, .6);
    }

    .patient-search-submit {
        border: none;
        border-radius: 0 4px 4px 0;
    }

    .patient-search-submit:focus,
    .patient-search-submit:focus:active,
    .patient-search-submit:active {
        outline: 5px auto rgba(255, 70, 0, 0.1);
    }

    .patient-search-submit:hover {
        color: rgb(255, 70, 0);
    }

    .dob-wrapper {
      display: flex;
    }
    .header-row {
      margin-top: 28px;
    }

    .patient-search-section {
      margin-top: 28px;
    }
</style>
